﻿import { createMiddleware } from 'redux-beacon';
import debounceEvent from '@redux-beacon/debounce-event';
import { addMiddleware } from 'redux-dynamic-middlewares';
import GoogleTagManager from 'middlewares/googleTagManager';
import GoogleAdsEventType from 'enums/googleAdsEventType';
import getGoogleAdsEvent from 'services/googleAdsBuilder';
import googleAdsEvent from './actions';

/**
 * The eventsMap function is a mapping of Redux actions to google ads events.
 * It returns an array of GoogleAdsEvent events
 * @param action Determine which event to return
 *
 * @return An array of events
 */
const eventsMap = (action) => {
  const payload = action.payload;
  if (action.type === googleAdsEvent.type) {
    const event = debounceEvent(100, getGoogleAdsEvent(GoogleAdsEventType.Event, payload.eventName));
    return event;
  }

  return [];
};

const googleTagManager = new GoogleTagManager();
const searchResultsGoogleTagManagerMiddleware = createMiddleware(eventsMap, googleTagManager.getTarget());
addMiddleware(searchResultsGoogleTagManagerMiddleware);
